<template>
	<div class="main" id="main">
		<Header @getHeaderHeight="getHeaderHeight"></Header>
		<div class="product" :style="{ 'padding-top': headerHeight - 1 + 'px' }">
			<Product></Product>
			<div class="os">
				<div class="os-container">
					<div class="header">
						<img src="../../static/img/icon-header-os.png" alt="">
					</div>
					<div class="introduction">
						<div class="introduction-wrap fl-jc fd-cl">
							<div class="rg">
								<div class="ornament-wrap">
									<div class="img-wrap lt">
										<img src="../../static/img/icon-ornament-1.png" alt="" />
									</div>
									<h4 class="animate">{{ $t('os.title') }}</h4>
									<div class="img-wrap rb">
										<img src="../../static/img/icon-ornament-1.png" alt="" />
									</div>
								</div>
								<div class="introduction-text">
									<p class="animate">{{ $t('os.intro') }}</p>
								</div>
							</div>
							<div class="lf">
								<img class="animate" src="/res/img/icon-atvos-img.png" alt="">
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 产品证书  -->
			<TvFeatures></TvFeatures>
			<!-- 固件 -->
			<!-- <TvFirmware></TvFirmware> -->
			<!-- 固件 -->
			<Remote></Remote>
		</div>

		<!-- 应用生态 -->
		<Application></Application>
		<TVEquipped></TVEquipped>
		<!-- 应用生态 -->
		<Footer></Footer>
		<SideBar></SideBar>
	</div>
</template>

<script>
	import Header from '../header/index.vue'
	import Footer from '../footer/index.vue'
	import Product from '../product/index.vue'
	import Application from '../application/index.vue'
	import Remote from '../remote/index.vue'
	import SideBar from '../sidebar/index.vue'
	import TvFeatures from '../features/index.vue'
	import TVEquipped from '../equipped/index.vue'

	const observers = []
	export default {
		name: "iptvIndex",
		components: {
			Header,
			Footer,
			Remote,
			Product,
			Application,
			SideBar,
			TvFeatures,
			TVEquipped
		},
		data() {
			return {
				headerHeight: ''
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.animateFn()
		},
		methods: {
			
			getHeaderHeight(val) {
				this.headerHeight = val
			},
			// 元素是否在视口
			isElementInViewport(element) {
				const rect = element.getBoundingClientRect()
				const isInViewport =
					rect.top >= 0 &&
					rect.bottom <=
					(window.innerHeight || document.documentElement.clientHeight)
				return isInViewport
			},
			animateFn() {
				const main = document.querySelectorAll('.animate') || []
				const paragraphs = [...main]
				paragraphs.forEach(item => {
					const observer = new IntersectionObserver(entries => {
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								// 元素进入视口
								item.classList.add('animate__animated')
								item.classList.add('animate__fadeInUp')
							}
						})
					})
					observer.observe(item)
					observers.push(observer)
				})
			},
			// 清空所有 observer 的函数
			destructionObserver() {
				observers.forEach(observe => {
					observe.disconnect()
				})
				observers.length = 0
			}
		},
		updated() {},
		beforeDestroy() {
			this.destructionObserver()
		}
	}
</script>
<style lang='less' scoped>
	.main {
		min-width: 320px;
		background-color: #051412;
	}

	@media (max-width: 1350px) {}


	@media (max-width: 768px) {}

	.os {
		padding: 72px 0 46px;

		.os-container {
			max-width: 1280px;
			margin: 0 auto;

			.header {
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0 24px 24px;

				img {
					max-width: 100%;
					max-height: 65px;
				}
			}
		}

		.introduction {
			padding: 0 24px;

			.introduction-wrap {
				.rg {
					.ornament-wrap {
						display: inline-block;

						h4 {
							font-family: 'Alibaba PuHuiTi H';
							font-weight: normal !important;
							font-size: 40px;
						}

						.rb {
							justify-content: flex-end;
							text-align: right;
						}

						.img-wrap {
							display: flex;
							align-items: center;

							img {
								width: 21px;
								height: 15px;
							}
						}
					}

					.introduction-text {
						max-width: 300px;
						padding-top: 12px;

						p {
							font-size: 15px;
						}
					}
				}

				.lf {
					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}

	.fl-jc {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	@media (max-width: 768px) {
		.fd-cl {
			flex-direction: column;
		}

		.rg {
			text-align: center;
		}

		.ornament-wrap {
			padding: 12px 0;

			h4 {
				display: inline-block !important;
			}
		}

		.introduction-text {
			text-align: center;
			max-width: 100% !important;
		}
	}
</style>